import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ChatInterface from './components/ChatInterface';
import AuthStatus from './components/AuthStatus';
import AuthCallback from './components/AuthCallback';
import './App.css';
import './components/AuthStatus.css';
import './components/AuthCallback.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* メインページ */}
            <Route path="/" element={
              <>
                <div className="app-header">
                  <AuthStatus />
                </div>
                <ChatInterface />
              </>
            } />
            
            {/* 認証コールバックページ */}
            <Route path="/callback" element={<AuthCallback />} />
            
            {/* 404ページ（オプション） */}
            <Route path="*" element={
              <div className="not-found">
                <h2>ページが見つかりません</h2>
                <p>お探しのページは存在しません。</p>
                <a href="/">ホームに戻る</a>
              </div>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
